/**
 * @generated SignedSource<<00626c5845f20a1f2fb003238c214976>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type stakeholdersCatPage_Query$variables = {
  from?: string | null | undefined;
  limit?: number | null | undefined;
  offset?: number | null | undefined;
  perspectiveId?: string | null | undefined;
  search?: string | null | undefined;
  uncategorized?: boolean | null | undefined;
};
export type stakeholdersCatPage_Query$data = {
  readonly categories: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
  }>;
  readonly costStakeholders: {
    readonly stakeholders: ReadonlyArray<{
      readonly category: {
        readonly color: string;
        readonly id: string;
        readonly name: string;
      } | null | undefined;
      readonly id: string;
      readonly name: string;
      readonly total: number;
    }>;
    readonly totalCount: number;
  };
};
export type stakeholdersCatPage_Query = {
  response: stakeholdersCatPage_Query$data;
  variables: stakeholdersCatPage_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "from"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "limit"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "offset"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "perspectiveId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "search"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "uncategorized"
},
v6 = {
  "kind": "Variable",
  "name": "perspectiveId",
  "variableName": "perspectiveId"
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v9 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "from",
        "variableName": "from"
      },
      {
        "kind": "Variable",
        "name": "limit",
        "variableName": "limit"
      },
      {
        "kind": "Variable",
        "name": "offset",
        "variableName": "offset"
      },
      (v6/*: any*/),
      {
        "kind": "Variable",
        "name": "search",
        "variableName": "search"
      },
      {
        "kind": "Variable",
        "name": "uncategorized",
        "variableName": "uncategorized"
      }
    ],
    "concreteType": "CostStakeholdersPayload",
    "kind": "LinkedField",
    "name": "costStakeholders",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Stakeholder",
        "kind": "LinkedField",
        "name": "stakeholders",
        "plural": true,
        "selections": [
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "total",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Category",
            "kind": "LinkedField",
            "name": "category",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "color",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": [
      (v6/*: any*/)
    ],
    "concreteType": "Category",
    "kind": "LinkedField",
    "name": "categories",
    "plural": true,
    "selections": [
      (v7/*: any*/),
      (v8/*: any*/)
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "stakeholdersCatPage_Query",
    "selections": (v9/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v0/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "stakeholdersCatPage_Query",
    "selections": (v9/*: any*/)
  },
  "params": {
    "cacheID": "e9469b087036943fffcd97ed155fc0e0",
    "id": null,
    "metadata": {},
    "name": "stakeholdersCatPage_Query",
    "operationKind": "query",
    "text": "query stakeholdersCatPage_Query(\n  $perspectiveId: ID\n  $from: String\n  $search: String\n  $uncategorized: Boolean\n  $limit: Int\n  $offset: Int\n) {\n  costStakeholders(perspectiveId: $perspectiveId, from: $from, search: $search, uncategorized: $uncategorized, limit: $limit, offset: $offset) {\n    totalCount\n    stakeholders {\n      id\n      name\n      total\n      category {\n        id\n        name\n        color\n      }\n    }\n  }\n  categories(perspectiveId: $perspectiveId) {\n    id\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "3259270cb6c7e350db7bf0ef0d9d4e5a";

export default node;
